<template>
  <!-- <transition name="slide" appear></transition> -->
  <div class="pageBody">
    <div class="pageScroll">
      <section class="banner cow">
        <div
          class="productBanner fwc"
          :style="{background:'url(' + require('../../assets/images/'+imgUrl) + ') no-repeat scroll center center / cover'}"
        >
          <!-- <img class="fadeInUp" src="../../assets/images/c21.png" width="auto" height="34%" /> -->
        </div>
      </section>
      <section class="cow fwc routeBox">
        <section class="cow fws routeDiv" style="width: 1200px">
          <img src="../../assets/images/c33.png" />
          <p>您的位置：</p>
          <router-link tag="span" :to="{ name:'home', query: {} }" replace>主页</router-link>
          <p>></p>
          <span>案例分析</span>
        </section>
      </section>
      <section class="cow productAll fwc">
        <div class="productDiv" style="margin-bottom:106px">
          <ul class="cow productTab fwf" v-if="caseType>5">
            <li
              v-for="(item, index) in caseType"
              v-bind:key="index"
              :index="index"
              @click="changeTab(item.id,index)"
              :class="['productLi2', { caseTabActive: tabIndex == index }]"
            >{{item.caseTypeName}}</li>
          </ul>
          <ul class="cow ptUl ptUl2 fsc">
            <li
              class="ptLi"
              v-for="(item, index) in caseData"
              v-bind:key="index"
              :index="index"
              @click="goChild(item.id,index)"
            >
              <img class="ptimg" :src="$fileUrl+item.cover" />
              <p>{{item.title}}</p>
              <span>了解更多></span>
              <!-- <p class="cow txtbk4">{{item.introduce}}</p> -->
            </li>
            <i class="ci"></i>
            <i class="ci"></i>
            <i class="ci"></i>
            <i class="ci"></i>
            <i class="ci"></i>
          </ul>
          <div class="cow fwe" v-show="caseData.length>0">
            <div id="pager" class="pager clearfix" style="margin-right:58px"></div>
          </div>
          <div class="cow fhc kong" v-show="!caseData.length>0">
            <img src="../../assets/images/kong.png" />
            <p>暂无更多</p>
          </div>
        </div>
      </section>
      <v-footer :tabActiveIndex="0"></v-footer>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { Lazyload } from "mint-ui";
import Swiper from "swiper";
import { mapMutations, mapGetters, mapState } from "vuex";
import $ from "jquery";
import { zPager } from "../../assets/js/jquery.z-pager";
import vHeader from "../../components/header/Header";
import vFooter from "../../components/footer/Footer";
import cases from "../../api/case.json";
export default {
  data() {
    return {
      imgUrl: "c36.jpg",
      // caseData: cases.caseData,
      // caseType: cases.caseType,
      caseData: [],
      caseType: [],
      tabIndex: 0,
      pageIndex: 1,
      pageSize: 9
    };
  },
  created() {},
  methods: {
    onBindDom() {
      var that = this;
      if (!this.IsPC()) {
        this.pageSize = 10;
      } else {
        this.pageSize = 9;
      }
      this.loadTypes();
    },
    loadTypes() {
      var that = this;
      this.$axios
        .reqCompanyCaseTypeList({
          params: {}
        })
        .then(res => {
          if (res.data.status === 200) {
            var arr = [{ id: "", caseTypeName: "全部主题体验馆" }];
            this.caseType = arr.concat(res.data.data);
            if (this.$route.query.typeId) {
              this.tabIndex = _.findIndex(that.caseType, function(o) {
                return o.id == that.$route.query.typeId;
              });
            }
            this.loadData();
          }
        });
    },
    loadData() {
      var that = this;
      this.$axios
        .reqCompanyCaseList({
          params: {
            title: "",
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            typeId: this.caseType[this.tabIndex].id
          }
        })
        .then(res => {
          if (res.data.status === 200) {
            this.caseData = res.data.data;
            $("#pager").zPager({
              totalData: res.data.totalNum,
              pageData: that.pageSize,
              current: that.pageIndex,
              pageStep: 6,
              minPage: 1,
              btnBool: true,
              btnShow: false,
              ajaxSetData: false,
              ajaxSetData: false,
              pageRender: function(data) {
                if (Number(data) != that.pageIndex) {
                  $(".pageScroll").animate({ scrollTop: 0 }, 600);
                  that.pageIndex = Number(data);
                  that.loadData();
                }
              }
            });
          }
        });
    },
    changeTab(id, index) {
      this.tabIndex = index;
      this.pageIndex = 1;
      this.$router.replace({
        path: "/case",
        query: { typeId: id }
      });
      this.loadData();
    },
    goChild(id, index) {
      this.$router.push({
        path: "/caseChild",
        query: { id: id }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  watch: {
    $route: {
      handler(n, o) {
        if (n.name == "case") {
          this.loadTypes();
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState(["cart"])
  },
  mounted() {
    this.onBindDom();
  },
  components: {
    vHeader,
    vFooter
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/reset/reset.css";
@import "../../assets/css/reset/common.less";
@import "../../assets/css/fonts/iconfont.css";
@import "../../assets/css/product.css";
@import "../../assets/css/hover.css";

.pageBody {
  .page-view();
}
.pageScroll {
  width: 100%;
  height: 100%;
  position: relative;
  float: left;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// case.vue?01535a7a